import React, { ComponentProps } from 'react'
import useTranslation from 'next-translate/useTranslation'
import Link from 'next/link'
import { Text } from 'components/Text'
import {
  StatisticsRoot,
  StatisticRow,
  Subtitle,
  Title,
  StatisticContainer,
  BadgeWrapper,
} from './Statistics.styles'
import Trans from 'next-translate/Trans'
import { Stack } from 'components/Stack'
import { Button } from 'components/Button'
import Image from 'next/image'
import badge from '../../../../../public/assets/icons/brand-refresh/wfr-since-forever-badge.webp'

type StatisticsOwnProps = ComponentProps<typeof StatisticsRoot>
export type StatisticsProps = StatisticsOwnProps & {}

export const Statistics = (_props: StatisticsProps) => {
  const { t } = useTranslation()

  const statList: string[] = ['1', '2', '3', '4', '5', '6']

  return (
    <StatisticsRoot id="recipes-4">
      <BadgeWrapper>
        <Image src={badge} alt="" />
      </BadgeWrapper>
      <Stack direction="column" justifyContent="center" alignItems="center" gap={{'@initial': '2', '@bp2': '4'}}>
        <Title align="center" size={{'@initial': 'h3', '@bp2':'h1'}} as="h2" color="accent-black" weight="regular">
          {t('recipes:overview.statistics.title')}
        </Title>
        <Subtitle align="center" size={{'@initial': 'body', '@bp2': 'h3'}} as="p" color="accent-black" weight="regular">
          {t('recipes:overview.statistics.description')}
        </Subtitle>
      </Stack>
      <StatisticContainer>
        {statList.map((stat) => (
          <StatisticRow key={stat}>
            <Text size={{'@initial': 'headline', '@bp2': 'h5'}} color="accent-black" weight="regular">
              <Trans
                i18nKey={`recipes:overview.statistics.stat-${stat}.desktop`}
              />
            </Text>
          </StatisticRow>
        ))}
      </StatisticContainer>
      <Stack
        justifyContent="center"
        css={{ marginTop: '12px' }}
      >
        <Link href="/meal-plan">
          <Button>{t('recipes:overview.cta-5')}</Button>
        </Link>
      </Stack>
    </StatisticsRoot>
  )
}

Statistics.displayName = 'Statistics'
